module.exports = __webpack_public_path__ + "static/workn_color-2258378b955832ada83212edd43e0082.jpg";